import { useEffect, useState } from "react";
import { Dialog, DialogContent, } from "@mui/material";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi';
import { Carousel } from 'react-responsive-carousel';
import styles from './Schecule.module.css'
import './Schecule.css'
import { SpeakerModal } from '../SpeakerModal';

export const ImgSlider = ({ speakers }) => {
   const [speakerIdx, setSpeakerIdx] = useState(null);
   const [imageCount, setImageCount] = useState(2);
   const [isArrows, setIsArrows] = useState(false)

   const handleClose = () => setSpeakerIdx(null);

   useEffect(() => {
      function updateImageCount() {
         if (window.matchMedia('(min-width: 1575px)').matches) {
            setImageCount(4);
            setIsArrows(speakers.length > 3)
         } else if (window.matchMedia('(min-width: 1275px)').matches) {
            setImageCount(3);
            setIsArrows(speakers.length > 3)

         } else if (window.matchMedia('(min-width: 925px)').matches) {
            setImageCount(2);
            setIsArrows(speakers.length > 2)

         } else {
            setImageCount(1)
            setIsArrows(speakers.length > 1)
         };
      }
      window.addEventListener('resize', updateImageCount);
      updateImageCount();
      return () => window.removeEventListener('resize', updateImageCount);
   }, []) // eslint-disable-line 

   if (!speakers) return <></>
   const slides = [];

   for (let i = 0; i < speakers.length; i += imageCount) {
      slides.push(speakers.slice(i, i + imageCount));
   }

   return (
      <Carousel
         id='agendaSpeakersCarousel'
         key={Math.random()}
         showStatus={false}
         infiniteLoop={true}
         showThumbs={false}
         transitionTime={500}
         renderArrowPrev={(clickHandler, hasPrev, label) => {
            return (
               isArrows ?
                  <span
                     className={styles.arrowLeft}
                     onClick={clickHandler}>
                     <BiLeftArrow style={{ color: '#CF1B5B' }} />
                  </span> : <></>
            )
         }}
         renderArrowNext={(clickHandler, hasNext, label) => {
            return (
               isArrows ?
                  <span
                     disabled
                     className={styles.arrowRight}
                     onClick={clickHandler}>
                     <BiRightArrow style={{ color: '#CF1B5B' }} />
                  </span> : <></>
            )
         }}
         renderIndicator={false}
      >
         {slides.map((slide, slideIdx) => (
            <div key={Math.random()} style={{ display: "flex", justifyContent: 'start' }}>
               {slide.map((card, cardIdx) => (
                  <div
                     key={Math.random()}
                     className={`${styles.speaker} `}
                     onClick={() => {
                        setSpeakerIdx(slideIdx * imageCount + cardIdx);
                     }}
                  >
                     <img
                        key={card?.headshot_url}
                        src={card?.headshot_url}
                        alt={card?.headshot_url}
                        style={{ width: "100px", height: "100%" }} />
                     <ul>
                        <li>{card?.is_moderator ? 'Moderator' : 'Speaker'}</li>
                        <li>{card?.firstname} {card?.lastname}</li>
                        <li>{card?.jobtitle?.slice(0, 20) + (card?.jobtitle?.length > 20 ? "..." : "")}</li>
                        <li>{card?.company?.slice(0, 20) + (card?.company?.length > 20 ? "..." : "")}</li>
                     </ul>
                  </div>
               ))}
            </div>
         ))}
         <Dialog
            disableScrollLock
            open={speakerIdx !== null}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
               sx: {
                  maxWidth: "1500px!important",
               },
            }}
         >
            <DialogContent style={{ overflow: "hidden" }}>
               <SpeakerModal speakers={speakers} speakerIdx={speakerIdx} handleClose={handleClose} />
            </DialogContent>
         </Dialog>
      </Carousel >
   );
};

